import { render } from "./OnlineCareRequestWithoutType.vue?vue&type=template&id=ca8febce&scoped=true&ts=true"
import script from "./OnlineCareRequestWithoutType.vue?vue&type=script&lang=ts"
export * from "./OnlineCareRequestWithoutType.vue?vue&type=script&lang=ts"

import "./OnlineCareRequestWithoutType.vue?vue&type=style&index=0&id=ca8febce&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\KOMEF\\vuejs-heselcare\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca8febce"]])

export default __exports__